/* assets/adore-rug.js
   1 Oct 2026, CRO build 4. Rug collections page (sections/adore-rug-ranges.liquid, snippets/adore-rug-card.liquid).
   - Tapping a design thumbnail shows that rug in the card's big photo, with its name, price and a
     "View this rug" link underneath. No double tap here: the panel advised a visible link instead.
   - Style buttons show only the cards of that style.
   - 1 Oct 2026 16:33: left and right arrows on the design rows (collection cards and product page row).
   - 1 Oct 2026 17:22: "Browse all collections" at the end of the Rug collections page and of each rug collection page.
   - 1 Oct 2026 17:34: size buttons on each card change the price to the lowest price in that size.
   - 2 Oct 2026 (panel UX): "Showing 12 of 64 collections" count, and coming Back to the page reopens the extra
     collections, the style picked and the place on the page.
   - 3 Oct 2026 (Nas): size buttons reflect the design showing. Sizes that design is not available in are dimmed
     (data-sizes only lists sizes in stock), and tapping one says so instead of looking available. */
(function () {
  if (window.adoreRugCards) return;
  window.adoreRugCards = true;
  document.addEventListener('click', function (e) {
    var th = e.target.closest('.rgc__th');
    if (th) {
      var card = th.closest('[data-rgc]');
      var img = card && card.querySelector('.rgc__img');
      if (img) {
        img.classList.add('is-swap');
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          img.srcset = th.dataset.srcset || ''; img.src = th.dataset.src; img.alt = th.dataset.name || '';
          img.classList.remove('is-swap');
        };
        pre.src = th.dataset.src;
      }
      [].forEach.call(card.querySelectorAll('.rgc__th'), function (b) {
        var on = b === th; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var out = card.querySelector('.rgc__pick');
      if (out) {
        out.textContent = '';
        var n = document.createElement('strong'); n.textContent = th.dataset.name || '';
        out.appendChild(n);
        // with a size picked, show this design's price in that size when it comes in it
        var sp = sizePrice(th, card.dataset.size);
        if (th.dataset.instore) {
          // 4 Oct 2026 (Nas): in-store-only ranges have no online price
          out.appendChild(document.createTextNode('. In store only, see it at Auburn. '));
        } else if (card.dataset.size && !sp) {
          // 3 Oct 2026 (Nas): this design is not available in the size picked, say so plainly
          out.appendChild(document.createTextNode(' is not available in ' + sizeLabel(card.dataset.size) + '. From ' + (th.dataset.price || '') + '. '));
        } else {
          out.appendChild(document.createTextNode(', from ' + (sp ? money(sp[0]) + ' (' + sizeLabel(card.dataset.size) + ')' : (th.dataset.price || '')) + '. '));
        }
        var a = document.createElement('a'); a.className = 'rgc__go'; a.href = th.dataset.url; a.textContent = 'View this rug';
        out.appendChild(a);
      }
      markSizes(card, th);
      return;
    }
    // 1 Oct 2026 17:34 (Nas): tapping a size shows the lowest price in that size on the card.
    var sz = e.target.closest('.rgc__sz');
    if (sz) { pickSize(sz); return; }
    // 1 Oct 2026 17:22 (Nas): "Browse all collections" on the Rug collections page opens the rest of the collections here.
    var mb = e.target.closest('[data-rg-more]');
    if (mb) { openMore(mb.closest('[data-rg-filter]')); return; }
    // ...and on a rug collection page it loads the collection cards from the Rug collections page into this page.
    var fb = e.target.closest('[data-rg-fetch]');
    if (fb) { fetchCards(fb); return; }
    var chip = e.target.closest('.rg__chip');
    if (chip) {
      var root = chip.closest('[data-rg-filter]'); var s = chip.getAttribute('data-style');
      if (s) openMore(root); // picking a style also loads every other collection, so the filter covers them all
      [].forEach.call(root.querySelectorAll('.rg__chip'), function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      [].forEach.call(root.querySelectorAll('[data-rgc]'), function (c) { c.hidden = !!s && c.getAttribute('data-style') !== s; });
      refreshAll(); count(root);
      return;
    }
    // 1 Oct 2026 16:33 (Nas): left and right arrows move the row by most of its width.
    var ar = e.target.closest('.rg-sc__arr');
    if (ar) {
      var list = ar.parentNode.querySelector('ul');
      if (list) list.scrollBy({ left: (ar.classList.contains('rg-sc__arr--prev') ? -1 : 1) * list.clientWidth * 0.8, behavior: 'smooth' });
    }
  });

  // ---- size buttons (1 Oct 2026 17:34) ----
  // Each design thumbnail carries data-sizes="160x230:29900:69000,round:19000:27000," (cents).
  function sizePrice(th, key) {
    if (!key) return null;
    var best = null;
    (th.dataset.sizes || '').split(',').forEach(function (x) {
      var a = x.split(':'); if (a[0] !== key) return;
      var p = +a[1], c = +a[2] || 0; if (!best || p < best[0]) best = [p, c];
    });
    return best;
  }
  function money(cents) { return '$' + (cents / 100).toLocaleString('en-AU', { maximumFractionDigits: 2 }); }
  function sizeLabel(key) { return key === 'round' ? 'Round' : key.replace('x', ' x ') + ' cm'; }
  function pickSize(btn) {
    var card = btn.closest('[data-rgc]'), key = btn.getAttribute('data-size'), best = null;
    [].forEach.call(card.querySelectorAll('.rgc__th'), function (th) {
      var sp = sizePrice(th, key); if (sp && (!best || sp[0] < best[0])) best = sp;
    });
    if (!best) return;
    card.dataset.size = key;
    [].forEach.call(card.querySelectorAll('.rgc__sz'), function (b) { var on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var pr = card.querySelector('.rgc__price'); if (!pr) return;
    pr.querySelector('strong').textContent = money(best[0]);
    var s = pr.querySelector('s'), off = pr.querySelector('.rgc__off');
    if (best[1] > best[0]) {
      if (s) { s.textContent = money(best[1]); s.hidden = false; }
      if (off) { off.textContent = Math.floor((best[1] - best[0]) * 100 / best[1]) + '% off'; off.hidden = false; }
    } else { if (s) s.hidden = true; if (off) off.hidden = true; }
    var lab = pr.querySelector('.rgc__size'); if (lab) lab.textContent = sizeLabel(key);
    // refresh the preview line if a design is showing
    var on = card.querySelector('.rgc__th.is-on'), pick = card.querySelector('.rgc__pick');
    if (on && pick && pick.querySelector('.rgc__go')) on.click();
    else if (on && pick && !sizePrice(on, key)) {
      // 3 Oct 2026 (Nas): no design previewed yet, but the first design does not come in this size: say so
      pick.textContent = (on.dataset.name || 'This design') + ' is not available in ' + sizeLabel(key) + '. Other designs here are, from ' + money(best[0]) + '. Tap a design to preview it.';
    }
  }
  // 3 Oct 2026 (Nas): dim the size buttons the showing design is not available in (sold out counts as not available).
  function markSizes(card, th) {
    var have = {};
    (th.dataset.sizes || '').split(',').forEach(function (x) { var k = x.split(':')[0]; if (k) have[k] = 1; });
    [].forEach.call(card.querySelectorAll('.rgc__sz'), function (b) {
      var off = !have[b.getAttribute('data-size')];
      b.classList.toggle('is-off', off);
      if (off) { b.setAttribute('aria-disabled', 'true'); b.title = (th.dataset.name || 'This design') + ' is not available in this size'; }
      else { b.removeAttribute('aria-disabled'); b.removeAttribute('title'); }
    });
  }
  function markAll() {
    [].forEach.call(document.querySelectorAll('[data-rgc]'), function (card) {
      if (card.dataset.szMarked) return; card.dataset.szMarked = '1';
      var th = card.querySelector('.rgc__th.is-on'); if (th) markSizes(card, th);
    });
  }

  // 1 Oct 2026 18:09: the extra collection cards are fetched when needed (button or a style pick), once.
  function applyFilter(root) {
    var on = root.querySelector('.rg__chip.is-on'), s = on ? on.getAttribute('data-style') : '';
    [].forEach.call(root.querySelectorAll('[data-rgc]'), function (c) { c.hidden = !!s && c.getAttribute('data-style') !== s; });
    bind(); refreshAll(); count(root);
  }
  // 2 Oct 2026: "Showing 12 of 64 collections" before the rest are loaded, then the number showing.
  function count(root) {
    var el = root && root.querySelector('[data-rg-count]'); if (!el) return;
    var cards = [].filter.call(root.querySelectorAll('.rg__grid [data-rgc]'), function (c) { return !c.hidden; }).length;
    var btn = root.querySelector('[data-rg-more]'), on = root.querySelector('.rg__chip.is-on'), s = on ? on.getAttribute('data-style') : '';
    var word = cards === 1 ? 'collection' : 'collections';
    if (btn && !btn.dataset.done) el.textContent = 'Showing ' + cards + ' of ' + el.getAttribute('data-total') + ' ' + word;
    else if (s) el.textContent = 'Showing ' + cards + ' ' + on.textContent.trim().toLowerCase() + ' ' + word;
    else el.textContent = 'Showing all ' + cards + ' ' + word;
  }
  function openMore(root, done) {
    if (!root) return;
    var btn = root.querySelector('[data-rg-more]'), grid = root.querySelector('.rg__grid'), status = root.querySelector('[data-rg-status]');
    if (!btn || !grid) return;
    if (btn.dataset.done || btn.dataset.busy) return;
    btn.dataset.busy = '1'; if (status) status.textContent = 'Loading collections...';
    fetch(btn.getAttribute('data-rg-more'), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        [].forEach.call(doc.querySelectorAll('[data-rgc]'), function (c) { grid.appendChild(document.importNode(c, true)); });
        btn.dataset.done = '1'; btn.hidden = true; delete btn.dataset.busy; if (status) status.textContent = '';
        applyFilter(root);
        if (done) done();
      })
      .catch(function () { delete btn.dataset.busy; if (status) status.textContent = 'Could not load the other collections. Please try again.'; });
  }
  function fetchCards(btn) {
    var root = btn.closest('[data-rg-filter]'), into = root.querySelector('[data-rg-into]'), status = root.querySelector('[data-rg-status]');
    if (btn.dataset.busy) return; btn.dataset.busy = '1';
    if (status) status.textContent = 'Loading collections...';
    var url = btn.getAttribute('data-rg-fetch'), skip = btn.getAttribute('data-rg-skip');
    // cards only, no header or footer: templates/page.rug-cards.json (sections/adore-rug-cards-feed.liquid)
    fetch(url + '?view=rug-cards', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = [].slice.call(doc.querySelectorAll('[data-rgc]'));
        if (!cards.length) throw new Error('no cards');
        cards.forEach(function (c) { if (c.getAttribute('data-handle') !== skip) into.appendChild(document.importNode(c, true)); });
        into.hidden = false; btn.hidden = true; if (status) status.textContent = '';
        bind(); refreshAll();
      })
      .catch(function () {
        // if loading fails, go to the Rug collections page instead
        window.location.href = url;
      });
  }

  // Show each arrow only when there is more to see that way.
  function refresh(wrap) {
    var list = wrap.querySelector('ul');
    var prev = wrap.querySelector('.rg-sc__arr--prev'), next = wrap.querySelector('.rg-sc__arr--next');
    if (!list || !prev || !next) return;
    var max = list.scrollWidth - list.clientWidth;
    prev.hidden = list.scrollLeft <= 2;
    next.hidden = list.scrollLeft >= max - 2;
  }
  function refreshAll() { [].forEach.call(document.querySelectorAll('[data-rg-scroll]'), refresh); }
  function bind() {
    [].forEach.call(document.querySelectorAll('[data-rg-scroll]'), function (wrap) {
      if (wrap.dataset.rgBound) return;
      wrap.dataset.rgBound = '1';
      var list = wrap.querySelector('ul');
      if (list) list.addEventListener('scroll', function () { refresh(wrap); }, { passive: true });
      refresh(wrap);
    });
    markAll();
  }
  // 2 Oct 2026 (panel UX): coming Back from a collection or a rug reopens the extra collections, the style picked and
  // the place on the page, so shoppers do not lose their spot. Saved per page in this browser tab only.
  var KEY = 'adoreRg:' + location.pathname;
  // On computers this theme scrolls the <body>, not the window, so read and set both.
  function getY() { return Math.max(window.scrollY || 0, document.body.scrollTop || 0, document.documentElement.scrollTop || 0); }
  function setY(y) { window.scrollTo(0, y); document.body.scrollTop = y; }
  window.addEventListener('pagehide', function () {
    var root = document.querySelector('.rg [data-rg-filter], .rg[data-rg-filter]'); if (!root) return;
    var btn = root.querySelector('[data-rg-more]'), on = root.querySelector('.rg__chip.is-on');
    try { sessionStorage.setItem(KEY, JSON.stringify({ more: !!(btn && btn.dataset.done), style: on ? on.getAttribute('data-style') : '', y: getY() })); } catch (e) {}
  });
  function restore() {
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!nav || nav.type !== 'back_forward') return;
    var st; try { st = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
    var root = document.querySelector('.rg[data-rg-filter]');
    if (!st || !st.more || !root) return;
    [].forEach.call(root.querySelectorAll('.rg__chip'), function (c) { var on = (c.getAttribute('data-style') || '') === (st.style || ''); c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    openMore(root, function () { setY(st.y || 0); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(); count(document.querySelector('.rg[data-rg-filter]')); restore(); });
  else { bind(); count(document.querySelector('.rg[data-rg-filter]')); restore(); }
  window.addEventListener('load', function () { bind(); refreshAll(); });
  window.addEventListener('resize', refreshAll);
})();
